import { Target, Users, Search, CheckCircle } from "lucide-react";

interface HeadhuntingSectionProps {
  isVisible: boolean;
}

const HeadhuntingSection = ({ isVisible }: HeadhuntingSectionProps) => {
  const steps = [
    {
      icon: Search,
      title: "לא 'מי מחפש' — אלא 'מי מתאים'",
      description: "כמו Headhunter בהייטק, אנחנו לא מחפשים מועמדים שמחפשים עבודה. אנחנו מזהים את המתאימים ביותר — גם אם הם לא על האפליקציות.",
    },
    {
      icon: Target,
      title: "סינון הוליסטי",
      description: "לא מסננים רק לפי תמונה או מיקום. מסננים לפי 50% רגש, 30% ערכים, 20% משיכה — בדיוק הסדר שמנבא הצלחה.",
    },
    {
      icon: Users,
      title: "איכות על פני כמות",
      description: "במקום עשרות דייטים של 'רעש' — מעט דייטים של 'סיגנל'. כל פגישה היא עם מישהו שעבר סינון עומק.",
    },
    {
      icon: CheckCircle,
      title: "ניטרול עיוורון ההתאהבות",
      description: "הפרוטוקול הופך את סדר הפעולות: קודם בודקים התאמה רגשית וערכית, רק אחר כך נותנים לכימיה לעשות את שלה.",
    },
  ];

  return (
    <section aria-labelledby="headhunting-heading" className="py-24 bg-gradient-to-b from-navy to-navy-dark relative">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-gold/10 border border-gold/30 rounded-full text-gold text-sm font-medium mb-6">
            השיטה
          </span>
          <h2 id="headhunting-heading" className="text-3xl md:text-4xl font-bold mb-4 text-cream">
            גישת <span className="text-gold">Headhunting</span> לזוגיות
          </h2>
          <p className="text-cream/70 text-lg max-w-2xl mx-auto">
            שאובה מעולמות גיוס הבכירים בהייטק — מותאמת לחיפוש בן/בת זוג
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {steps.map((step, index) => (
            <article
              key={step.title}
              className={`p-8 rounded-2xl bg-gradient-to-br from-gold/10 to-gold/5 border border-gold/20 backdrop-blur-sm transition-all duration-700 hover:border-gold/40 hover:shadow-lg hover:shadow-gold/5 ${
                isVisible 
                  ? "opacity-100 translate-y-0" 
                  : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div className="w-14 h-14 rounded-2xl bg-navy flex items-center justify-center mb-6">
                <step.icon className="w-7 h-7 text-gold" aria-hidden="true" />
              </div>
              <h3 className="text-xl font-bold text-cream mb-3">{step.title}</h3>
              <p className="text-cream/80 leading-relaxed">{step.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeadhuntingSection;
